import styled from '@emotion/styled';

export const ToggleSwitch = styled.div`
	position: relative;
	width: 4rem;
	min-width: 4rem;
	height: 2rem;
	background-color: transparent;

	label {
		position: absolute;
		right: 0;
		body[dir='rtl'] & {
			right: unset;
			left: 0;
		}
		width: 100%;
		height: 100%;
		background-color: var(--black-20);
		border-radius: var(--spacing-4);
		cursor: pointer;
	}

	:hover label {
		background-color: var(--black-30);
	}

	input {
		position: absolute;
		display: none;
		transition: all 0.3s;

		:checked ~ .slider {
			background-color: var(--blue);
		}

		:checked:hover:not(:disabled) ~ .slider {
			background-color: var(--blue-hover);
		}

		:disabled ~ .slider {
			background-color: var(--input-disabled-bg-color);
			cursor: not-allowed;
		}

		:checked ~ .slider::before {
			transform: translateX(2rem);
			body[dir='rtl'] & {
				transform: translateX(-2rem);
			}
			background-color: var(--white);
		}
	}

	.slider {
		position: absolute;
		width: 100%;
		height: 100%;
		border-radius: var(--spacing-4);
		transition: all 0.3s;
	}

	.slider::before {
		content: '';
		position: absolute;
		top: 0.25rem;
		left: 0.25rem;
		body[dir='rtl'] & {
			left: unset;
			right: 0.25rem;
		}
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		background-color: var(--white);
		transition: all 0.3s;
	}
`;
